<script>
  import { ignore } from '../../../Common/tools';
  import { onMount } from 'svelte';
  import WebComponents from '../../../main.js';
  import { External, M } from '../../../external.js';
  import { loadPlayerScripts } from '../../../Video/static';

  export let data;
  export let valid;
  export let onChange = ignore;

  let targetFrameStr = '';
  let result = {
    videoId: null,
    targetFrame: null
  };

  let currentVideo = null;
  let previewKey = 1;
  let plyrPreview = null;

  let loadPlyrPreview = (videoPreviewHolder) => {
    loadPlayerScripts(() => {
      plyrPreview = new window.Plyr(videoPreviewHolder, {
        controls: false,
        settings: [],
        clickToPlay: false,
        fullscreen: {
          enabled: false
        }
      });

      if (window.Hls.isSupported()) {
        let hslConfig = {
          //length in seconds
          maxBufferLength: 9,
          //length in seconds
          maxMaxBufferLength: 10,
          //size in bytes
          maxBufferSize: 20 * 1000 * 1000
        };
        let hls = new window.Hls(hslConfig);
        hls.loadSource(currentVideo.videoPath);
        hls.attachMedia(videoPreviewHolder);
      }

      plyrPreview.on('ready', () => {
        plyrPreview.muted = true;
        plyrPreview.volume = 0;
      });
      plyrPreview.on('loadeddata', () => {
        plyrPreview.currentTime = result.targetFrame;
      });
    });
    return {
      destroy: () => {
        if (plyrPreview) {
          plyrPreview.destroy();
          plyrPreview = null;
        }
      }
    };
  };

  //triggered when slider for video loop as a thumb is shown
  let loadPlyrPreviewSlider = (node) => {
    let sliderHolder = {
      min: 0,
      max: currentVideo.durationInMs,
      value: result.targetFrame * 1000,
      element: External.$(node)
    };
    External.Tools.addSlider(sliderHolder);
    sliderHolder.element.on('slide', function (event, ui) {
      plyrPreview.currentTime = ui.value / 1000;
      targetFrameStr = millisecondsToTimestamp(ui.value);
    });
    sliderHolder.element.on('slidestop', function (event, ui) {
      result.targetFrame = ui.value / 1000;
      plyrPreview.currentTime = ui.value / 1000;
      onResultChange();
    });
    return {
      destroy() {
        sliderHolder.element.slider('destroy');
      }
    };
  };

  let millisecondsToTimestamp = (milliseconds) => {
    if (!milliseconds || milliseconds === 0) {
      return '00:00.00';
    }
    let minutes = Math.floor(milliseconds / 1000 / 60);
    let seconds = (milliseconds / 1000 - minutes * 60).toFixed(2);
    return minutes.toString().padStart(2, '0') + ':' + seconds.padStart(5, '0');
  };

  const onSelectVideo = () => {
    WebComponents.VideoService.videoPicker((videoObject) => {
      if (!videoObject) {
        return;
      }
      result.videoId = videoObject.id;
      currentVideo = videoObject;
      previewKey++;

      result.targetFrame = 0;
      targetFrameStr = millisecondsToTimestamp(result.targetFrame * 1000);

      onResultChange();
    });
  };

  const onResultChange = () => {
    if (result.videoId) {
      data.settings = [];
      data.settings.push({
        key: '0',
        value: JSON.stringify(result)
      });

      data.name = `"${currentVideo.title}"`;
      valid = true;
      onChange();
    } else {
      valid = false;
    }
  };

  const fetchSelectedVideo = async () => {
    if (result.videoId) {
      currentVideo = await WebComponents.VideoService.getVideoService('/file/' + result.videoId);
      previewKey++;
    }
  };

  onMount(async () => {
    data.settings = data.settings || [];

    if (data.settings.length > 0) {
      result = JSON.parse(data.settings[0].value);
      targetFrameStr = millisecondsToTimestamp(result.targetFrame * 1000);
      await fetchSelectedVideo();
    }
  });
</script>

<div class="col20 f-left small-rules mb-15">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">
    {M.TARGET_FRAME}
  </h4>
  <div class="popup-input-wrapper f-left mt-15">
    {#if currentVideo}
      <div on:click={onSelectVideo} class="col20 f-left ui-sorable form-admin-style-2 video-sortable-item mb-0">
        <div class="col20 f-left">
          <div class="form-step-wrapper flex align-center">
            <div class="flex align-center flex-1 video-arrange-wrapper">
              <div class="crm-folder-thumb-outer">
                <span
                  class="crm-folder-thumb"
                  style="background-image: url({External.getThumbnailsFromBase(
                    currentVideo.thumbnailFileBase,
                    '640x480'
                  ) +
                    currentVideo.thumbnailFileName +
                    '?format=webp'});"></span>
              </div>
              <div class="col20 f-left">
                <span
                  class="step-name ml-15 col20-important f-left added-video-edit-properties"
                  style="cursor: pointer;">{currentVideo.title}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {#key previewKey}
        <div class="popup-input-wrapper mt-15 mb-15">
          <video crossorigin playsinline use:loadPlyrPreview></video>
        </div>
        <div use:loadPlyrPreviewSlider></div>
      {/key}
      {targetFrameStr}
    {:else}
      <div class="col20 f-left t-center">
        <a class="middle-button blue f-none inline-block" on:click={onSelectVideo}>{M.SELECT_VIDEO}</a>
      </div>
    {/if}
  </div>
</div>
